import { axiosAzure } from '../interceptors/axios-azure';

const { VITE_API_BASE_URL_MEG } = import.meta.env;


export const httpGetVerifyClrEnrlmnt = (acquireToken) => {
  let url = `${VITE_API_BASE_URL_MEG}/verify`;
  return axiosAzure({ method: 'get', url, acquireToken });
};

export const httpGetRedirectClrEnrlmnt = (acquireToken, consent_id) => {
  const url = `${VITE_API_BASE_URL_MEG}/redirect?consent_id=${consent_id}`;
  return axiosAzure({ method: 'get', url, acquireToken });
};
